import React, { FC } from "react";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FormLabel, FormControl } from "@material-ui/core";
import { de } from 'date-fns/locale';
import { useTranslation } from "react-i18next";

interface Props {
    label?: string;
    labelType?: "in" | "out";
    value: Date | null;
    disabled?: boolean;
    onChange: (value: MaterialUiPickersDate) => void;
}

const DateTimePickerField: FC<Props> = ({
    value,
    onChange,
    label,
    labelType = "in",
    disabled = false,
    ...props
}) => {
    const { t } = useTranslation();
    return (
        <div className="field-container">
            <FormControl>
                <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                    <>
                        {labelType === "out" && <FormLabel>{label}</FormLabel>}
                        <KeyboardDatePicker
                            label={labelType === "in" ? label : ""}
                            variant="dialog"
                            inputVariant="outlined"
                            format="dd.MM.yyyy"
                            onChange={onChange}
                            value={value}
                            disabled={disabled}
                            cancelLabel={t('cancel')}
                            okLabel={t('ok')}
                        />
                    </>
                </MuiPickersUtilsProvider>
            </FormControl>
        </div>
    );
};

export default DateTimePickerField;
